import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Mission from '../components/Mission';
import Programs from '../components/Programs';
import Testimonials from '../components/Testimonials';
import GetInvolved from '../components/GetInvolved';
import './Home.css';

const NEWS = [
  {
    image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=800&h=450&q=80',
    tag: 'Education',
    date: 'June 15, 2026',
    title: '500 New Scholarships Awarded to Rural Girls Across Tamil Nadu',
    excerpt: 'This year, Shine People Trust expanded its scholarship program to reach girls in five new districts, ensuring no financial barrier stops a child from learning.',
  },
  {
    image: 'https://images.unsplash.com/photo-1662470186780-b5e97bb715e8?auto=format&fit=crop&w=800&h=450&q=80',
    tag: 'Healthcare',
    date: 'May 28, 2026',
    title: 'Free Eye Camp Restores Vision for 200 Villagers in Dindigul',
    excerpt: 'Our latest mobile medical camp provided free eye surgeries and spectacles to over 200 patients who had no access to ophthalmology services.',
  },
  {
    image: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?auto=format&fit=crop&w=800&h=450&q=80',
    tag: 'Environment',
    date: 'May 10, 2026',
    title: 'Rainwater Harvesting Project Now Serves 12 Villages in Erode',
    excerpt: 'After two years of community-driven construction, the watershed project now provides clean water to 4,000 residents throughout the dry season.',
  },
];

export default function Home() {
  return (
    <main id="main-content">
      <Hero />
      <Stats />
      <Mission />
      <Programs />

      {/* Latest News */}
      <section className="home-news" aria-labelledby="news-heading">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Stay Informed</span>
            <h2 className="section-title" id="news-heading">Latest News & Updates</h2>
            <p className="section-subtitle">
              Stories from the field, program updates, and announcements from Shine People Trust.
            </p>
          </div>

          <div className="news-grid" role="list">
            {NEWS.map(n => (
              <article className="news-card" key={n.title} role="listitem">
                <div className="news-card-img">
                  <img src={n.image} alt={n.title} className="news-card-photo" loading="lazy" />
                  <div className="news-card-img-overlay" aria-hidden="true" />
                </div>
                <div className="news-card-body">
                  <div className="news-card-meta">
                    <span className="news-tag">{n.tag}</span>
                    <time className="news-date" dateTime={n.date}>{n.date}</time>
                  </div>
                  <h3 className="news-card-title">{n.title}</h3>
                  <p className="news-card-excerpt">{n.excerpt}</p>
                  <Link to="/news" className="news-read-more">
                    Read More <span aria-hidden="true">&rarr;</span>
                  </Link>
                </div>
              </article>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
            <Link to="/news" className="btn btn-outline">View All Updates</Link>
          </div>
        </div>
      </section>

      <Testimonials />
      <GetInvolved />
    </main>
  );
}
